import { createAsyncAction } from 'store/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import { CalendarAppointment, BlockHour } from 'types/models';

// fetch payload is the raw query string; success payloads come from the calendar
// mappers (mappingApt / mappingBlockHour)
const getAptData = createAsyncAction<string, CalendarAppointment[]>(PREFIX_ACTIONS + 'getAptData');
const getBlockHourData = createAsyncAction<string, BlockHour[]>(PREFIX_ACTIONS + 'getBlockHourData');

const aptActions = {
  getAptData,
  getBlockHourData,
};

export default aptActions;

